import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import ScopeToggle from "../../components/ScopeToggle";
import MyExpensesPage from "./MyExpensesPage";
import TeamExpensesPage from "./TeamExpensesPage";
import AllExpensesPage from "./AllExpensesPage";
// Both manager tiers file their own claims, so they get a My/Team switch.
// Admin and Director don't file — they keep the company-wide view.
import { SELF_SERVICE_MANAGERS } from "../../lib/roleOptions";

export default function ExpensesRouter() {
  const { user } = useAuth();
  const role = user?.role;
  const [scope, setScope] = useState("team");

  if (role === "sales_officer") return <MyExpensesPage />;

  if (SELF_SERVICE_MANAGERS.includes(role)) {
    return (
      <div className="space-y-6">
        <ScopeToggle scope={scope} onChange={setScope} testIdPrefix="expenses" />
        {scope === "me" ? <MyExpensesPage soId={user.id} /> : <TeamExpensesPage />}
      </div>
    );
  }

  return <AllExpensesPage />;
}
